import JoinRequestForm from './components/JoinRequestForm';
import './components/JoinRequestForm.css';

function App() {
  const handleSuccess = (data: any) => {
    console.log('Join request submitted successfully:', data);
    // Additional success handling can be added here
  };

  const handleError = (error: string) => {
    console.error('Join request failed:', error);
    // Additional error handling can be added here
  };

  return (
    <div className="App">
      <JoinRequestForm 
        onSuccess={handleSuccess}
        onError={handleError}
      />
    </div>
  );
}

export default App; 